import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import DashboardLayout from "./components/layout/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import KumbhSahayak from "./pages/KumbhSahayak";
import AIAssurance from "./pages/AIAssurance";
import ModelTrust from "./pages/ModelTrust";
import CrowdIntelligence from "./pages/CrowdIntelligence";
import DigitalTwin from "./pages/DigitalTwin";
import GeoIntelligence from "./pages/GeoIntelligence";
import FieldOps from "./pages/FieldOps";
import PilgrimSupport from "./pages/PilgrimSupport";
import EmergencyResponse from "./pages/EmergencyResponse";
import ServiceMonitoring from "./pages/ServiceMonitoring";
import MissingPersons from "./pages/MissingPersons";
import MobilityIntelligence from "./pages/MobilityIntelligence";
import HealthIntelligence from "./pages/HealthIntelligence";
import WarRoom from "./pages/WarRoom";
import PublicComms from "./pages/PublicComms";
import Governance from "./pages/Governance";
import KumbhathonIntegration from "./pages/KumbhathonIntegration";
import ExecutiveIntelligence from "./pages/ExecutiveIntelligence";
import RiskIntelligence from "./pages/RiskIntelligence";
import Infrastructure from "./pages/Infrastructure";
import DisasterManagement from "./pages/DisasterManagement";
import PoliceModernization from "./pages/PoliceModernization";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { PreferencesProvider } from "./context/PreferencesContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AuthedApp() {
  const { user } = useAuth();
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*"      element={<Landing />} />
      </Routes>
    );
  }
  return (
    <DashboardLayout>
      <Routes>
          {/* Overview */}
          <Route path="/"                    element={<DashboardHome />} />
          <Route path="/sahayak"             element={<KumbhSahayak />} />

          {/* Strategic */}
          <Route path="/executive"           element={<ExecutiveIntelligence />} />
          <Route path="/risk-intelligence"   element={<RiskIntelligence />} />

          {/* Operations */}
          <Route path="/command"             element={<WarRoom />} />
          <Route path="/ai-assurance"        element={<AIAssurance />} />
          <Route path="/ai-trust"            element={<ModelTrust />} />
          <Route path="/crowd-intelligence"  element={<CrowdIntelligence />} />
          <Route path="/digital-twin"        element={<DigitalTwin />} />
          <Route path="/geo-intelligence"    element={<GeoIntelligence />} />

          {/* Pilgrim Help */}
          <Route path="/field-ops"           element={<FieldOps />} />
          <Route path="/pilgrim-support"     element={<PilgrimSupport />} />
          <Route path="/missing"             element={<MissingPersons />} />
          <Route path="/public-comms"        element={<PublicComms />} />

          {/* Emergency & Safety */}
          <Route path="/emergency"           element={<EmergencyResponse />} />
          <Route path="/services"            element={<ServiceMonitoring />} />
          <Route path="/mobility"            element={<MobilityIntelligence />} />
          <Route path="/health"              element={<HealthIntelligence />} />

          {/* Disaster & Infrastructure */}
          <Route path="/disaster-mgmt"       element={<DisasterManagement />} />
          <Route path="/infrastructure"      element={<Infrastructure />} />
          <Route path="/police-modern"       element={<PoliceModernization />} />

          {/* Command & Governance */}
          <Route path="/governance"          element={<Governance />} />
          <Route path="/kumbhathon"          element={<KumbhathonIntegration />} />

          {/* Signed-in users hitting /login, /, or an unknown path land on the console */}
          <Route path="*"                    element={<Navigate to="/" replace />} />
      </Routes>
    </DashboardLayout>
  );
}

export default function App() {
  return (
    <PreferencesProvider>
      <AuthProvider>
        {/* PUBLIC_URL is "" for `npm run dev` (app at /) and "/kumbh-ai" for
            `npm run build:pages` (app under the Pages sub-path). Setting it
            via `homepage` in package.json instead would also apply to the dev
            server, which moves localhost to /kumbh-ai/ and leaves / blank —
            that is exactly the bug this arrangement avoids. */}
        <BrowserRouter basename={process.env.PUBLIC_URL || ""}>
          <ScrollToTop />
          <AuthedApp />
        </BrowserRouter>
      </AuthProvider>
    </PreferencesProvider>
  );
}
